module.exports = __webpack_public_path__ + "static/media/press_releases.1926d970.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PressReleases/press_releases.svg
// module id = 98
// module chunks = 0